export const LANGUAGE_BY_CODE = {
  en: 'English',
  hy: 'Armenian',
  az: 'Azerbaijani',
  bg: 'Bulgarian',
  ca: 'Catalan',
  hr: 'Croatian',
  cs: 'Czech',
  da: 'Danish',
  nl: 'Dutch',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  ka: 'Georgian',
  de: 'German',
  el: 'Greek',
  he: 'Hebrew',
  hu: 'Hungarian',
  is: 'Icelandic',
  it: 'Italian',
  kk: 'Kazakh',
  lv: 'Latvian',
  lt: 'Lithuanian',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sr: 'Serbian',
  sk: 'Slovak',
  sl: 'Slovenian',
  es: 'Spanish',
  sv: 'Swedish',
  uk: 'Ukrainian'
}

export const LANGUAGES = Object.entries(LANGUAGE_BY_CODE).map(([code, label]) => ({ code, label }))

// Languages the MM21 head unit supports (TB-12352). Flemish has no code of its own: MM maps it to `nl`.
export const MM21_SUPPORTED_LANGUAGE_CODES = [
  'en',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'nl',
  'sv',
  'no',
  'da',
  'ru',
  'fi',
  'el',
  'pl',
  'uk',
  'tr',
  'hu',
  'cs',
  'sk',
  'ro',
  'et',
  'he',
  'sr',
  'hr',
  'sl',
  'lv',
  'lt'
]

export const rtlLanguagesISO2Codes = ['ar', 'he', 'fa', 'ur', 'ps', 'am', 'dv']

export const regulatedLanguages = ['uk', 'sl', 'tr', 'ro', 'ru']
